import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.css';

class MobileMenuLink extends Component {
    state = {
        windowWidth: window.innerWidth
    };

    componentDidMount() {
        window.addEventListener('resize', e => {
            const windowWidth = window.innerWidth;

            if (windowWidth > this.state.windowWidth && windowWidth >= 768) {
                this.props.onResizeToDesktop();
            }

            this.setState({
                windowWidth
            });
        });
    }

    render() {
        const { onMenuClick } = this.props;
        return (
            <div className="MobileMenuLink" onClick={() => onMenuClick()}>
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="Work"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            transform="translate(-428.000000, -32.000000)"
                            fill="#6C6C6C"
                        >
                            <g transform="translate(32.000000, 26.000000)">
                                <g transform="translate(396.000000, 6.000000)">
                                    <path
                                        d="M18,20 C16.8954305,20 16,19.1045695 16,18 C16,16.8954305 16.8954305,16 18,16 C19.1045695,16 20,16.8954305 20,18 C20,19.1045695 19.1045695,20 18,20 Z M10,20 C8.8954305,20 8,19.1045695 8,18 C8,16.8954305 8.8954305,16 10,16 C11.1045695,16 12,16.8954305 12,18 C12,19.1045695 11.1045695,20 10,20 Z M2,20 C0.8954305,20 0,19.1045695 0,18 C0,16.8954305 0.8954305,16 2,16 C3.1045695,16 4,16.8954305 4,18 C4,19.1045695 3.1045695,20 2,20 Z M18,12 C16.8954305,12 16,11.1045695 16,10 C16,8.8954305 16.8954305,8 18,8 C19.1045695,8 20,8.8954305 20,10 C20,11.1045695 19.1045695,12 18,12 Z M10,12 C8.8954305,12 8,11.1045695 8,10 C8,8.8954305 8.8954305,8 10,8 C11.1045695,8 12,8.8954305 12,10 C12,11.1045695 11.1045695,12 10,12 Z M2,12 C0.8954305,12 0,11.1045695 0,10 C0,8.8954305 0.8954305,8 2,8 C3.1045695,8 4,8.8954305 4,10 C4,11.1045695 3.1045695,12 2,12 Z M18,4 C16.8954305,4 16,3.1045695 16,2 C16,0.8954305 16.8954305,0 18,0 C19.1045695,0 20,0.8954305 20,2 C20,3.1045695 19.1045695,4 18,4 Z M10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 C11.1045695,0 12,0.8954305 12,2 C12,3.1045695 11.1045695,4 10,4 Z M2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 C3.1045695,0 4,0.8954305 4,2 C4,3.1045695 3.1045695,4 2,4 Z"
                                        id="Combined-Shape"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        );
    }
}

MobileMenuLink.propTypes = {
    onMenuClick: PropTypes.func
};

MobileMenuLink.defaultProps = {
    onMenuClick: () => true
};

export default MobileMenuLink;



// WEBPACK FOOTER //
// ./src/components/molecules/mobileMenuLink/index.js